
$(function () {
  /*==================================================
footer追従 footer超えたらfadeIn
==================================================*/
  function fixed(item, value) {
    if ($(item).length) {
      setTimeout(function () {
        var scrollEnd = $('.footer').offset().top;
        var distance = 0;
        $(document).scroll(function () {
          distance = $(this).scrollTop(); //スクロールした距離を取得
          if (scrollEnd - value < distance) { //スクロール距離が『.contact』の位置を超えたら
            $(item).addClass('none'); //class『none』を追加
          } else {
            $(item).removeClass('none'); //class『none』を削除
          }
        });
      }, 1000);//ページ上部からの距離を取得
    }
  };
  fixed('.sidebar__search-btn.button', 500);
  fixed('.footer-submit', 900);
  fixed('.js-recruit-btn', 1500);
  fixed('.price__list', 900);

  if ($('body.lp.company, body.lp.user').length) {
    setTimeout(function () {
      // var scrollEnd = $('.section.cv').offset().top;
      var scrollEnd = $('.section.cv').offset().top;
      var distance = 0;

      $(document).scroll(function () {
        distance = $(this).scrollTop(); //スクロールした距離を取得
        if (scrollEnd -1000 < distance) { //スクロール距離が『.contact』の位置を超えたら
          $('.footer-submit__lp').addClass('none'); //class『none』を追加
        } else {
          $('.footer-submit__lp').removeClass('none'); //class『none』を削除
        }
      });
    }, 1000);//ページ上部からの距離を取得
  }
});
